import { Component, OnInit } from '@angular/core';
import { ApiResponse } from '../../shared/models/api-response';
import { StateService } from '../../shared/services/state.service';
import { ChaptersService } from '../../chapters/chapters.service';
import { ChapterInfo } from '../../chapters/chapters.models';
import { SessionService } from '../../shared/services/session.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import * as $ from "jquery";


@Component({
  selector: 'app-yr3-st-storybookshelf',
  templateUrl: './yr3-st-storybookshelf.component.html',
  styleUrls: ['./yr3-st-storybookshelf.component.scss']
})
export class Yr3StStorybookshelfComponent implements OnInit {

  licenseId: string;
  chapters: ChapterInfo[];

  errorMessage: string;

  public bloburl: string;
  public chapterslist: string;
  public chapterlength;
  public mydevice: string = "";


  constructor(private route: ActivatedRoute,
    private chapterService: ChaptersService,
    private sessionService: SessionService,
    private stateService: StateService) {

    this.bloburl = this.sessionService.bloburl;

  }
  getChapters(studentLicenseId: string): void {
  
    this.chapterService.getAvailableChapters(studentLicenseId).subscribe((data: ApiResponse<ChapterInfo[]>) => {
      this.chapterslist = "";
      if (data.success) {
        this.chapters = data.payload;
        for (let j = 0; j <= 14; j++) {
    
          if (this.chapters[j].selected.valueOf() == true) {
            if (this.chapterslist == "") {
              this.chapterslist = j.toString()
            }
            else {
              this.chapterslist = this.chapterslist + "," + j.toString();
            }
          }
        }
      this.loadScript1(this.chapterslist);
      }
      else {
        this.errorMessage = `Fel vid hämtning av kapitel, fel: ${data.errorMessage}`;
      }

    });

  }

  ngOnInit() {
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var userAgent = navigator.userAgent.toLowerCase();
    var android_dev = userAgent.indexOf("android") > -1;
    var chrome_browser = userAgent.indexOf("chrome") > -1;
    var samsung_browser = userAgent.indexOf("samsung") > -1;
    if (isIOS) {
      this.mydevice = "ipad";
    }
    else if (android_dev) {
      this.mydevice = "android";

      if (samsung_browser) {
        this.mydevice = this.mydevice + "_samsung";
      }
      else if (chrome_browser) {
        this.mydevice = this.mydevice + "_chrome";

      }
      var body = document.body;
      body.classList.add(this.mydevice);
    }
    $(document).ready(function () {
      $('#closenavbutton').hide();
      $('#opennavbutton').hide();
      $('#opennavbutton').css("opacity", 0);
      $('#closenavbutton').css("opacity", 0);
      $(".rb_ch").hide();
      $(".wb_ch").hide();
    });
 
    this.licenseId = this.stateService.getLicenseId();
    if (!this.licenseId) {
      this.errorMessage = "Saknar licenseId"
    } else {
      this.getChapters(this.licenseId);
    }
  }

  private loadScript1(liststring) {
  
    this.bloburl = this.sessionService.bloburl;

    let stringToSplit = liststring;
   
    let x = stringToSplit.split(",");
    for (let i = 0; i <= 14; i++) {

      if (x[i] == "0") {
        var element = <HTMLInputElement>document.getElementById("image1");
        element.setAttribute("style", "opacity:1");
        element.removeAttribute("disabled");
      }

      if (x[i] == "1") {
        var element = <HTMLInputElement>document.getElementById("image2");
        element.removeAttribute("disabled");
        element.setAttribute("style", "opacity:1");
      }
      if (x[i] == "2") {
        var element = <HTMLInputElement>document.getElementById("image3");
        element.removeAttribute("disabled");
        element.setAttribute("style", "opacity:1");
      }
      if (x[i] == "3") {
        var element = <HTMLInputElement>document.getElementById("image4");
        element.removeAttribute("disabled");
        element.setAttribute("style", "opacity:1");

      }
      if (x[i] == "4") {
        var element = <HTMLInputElement>document.getElementById("image5");
        element.removeAttribute("disabled");
        element.setAttribute("style", "opacity:1");
      }
      if (x[i] == "5") {
        var element = <HTMLInputElement>document.getElementById("image6");
        element.removeAttribute("disabled");
        element.setAttribute("style", "opacity:1");
      }
      if (x[i] == "6") {
        var element = <HTMLInputElement>document.getElementById("image7");
        element.removeAttribute("disabled");
        element.setAttribute("style", "opacity:1");
      }
      if (x[i] == "7") {
        var element = <HTMLInputElement>document.getElementById("image8");
        element.removeAttribute("disabled");
        element.setAttribute("style", "opacity:1");
      }
      if (x[i] == "8") {
        var element = <HTMLInputElement>document.getElementById("image9");
        element.removeAttribute("disabled");
        element.setAttribute("style", "opacity:1");
      }
      if (x[i] == "9") {
        var element = <HTMLInputElement>document.getElementById("image10");
        element.removeAttribute("disabled");
        element.setAttribute("style", "opacity:1");
      }
      if (x[i] == "10") {
        var element = <HTMLInputElement>document.getElementById("image11");
        element.removeAttribute("disabled");
        element.setAttribute("style", "opacity:1");
      }
      if (x[i] == "11") {
        var element = <HTMLInputElement>document.getElementById("image12");
        element.removeAttribute("disabled");
        element.setAttribute("style", "opacity:1");
      }

      if (x[i] == "12") {
        var element = <HTMLInputElement>document.getElementById("image13");
        element.removeAttribute("disabled");
        element.setAttribute("style", "opacity:1");
      }
      if (x[i] == "13") {
        var element = <HTMLInputElement>document.getElementById("image14");
        element.removeAttribute("disabled");
        element.setAttribute("style", "opacity:1");
      }
      if (x[i] == "14") {
        var element = <HTMLInputElement>document.getElementById("image15");
        element.removeAttribute("disabled");
        element.setAttribute("style", "opacity:1");
      }
    }
  }
}
